import { optionSubcategory_accessibility } from './accessibilitySubCategory.locstring.json';
import { AccessibilityOption } from 'owa-accessibility-option';
import { NotificationTimingOption } from 'owa-notification-timing-option';
import { OptionSubCategory } from 'owa-options-core';
import { KeyboardShortcutsOption } from 'owa-shortcut-option';

let accessibilitySubCategory: OptionSubCategory = {
    key: 'accessibility',
    titleStringKey: optionSubcategory_accessibility,
    options: [KeyboardShortcutsOption, AccessibilityOption, NotificationTimingOption],
};

export default accessibilitySubCategory;
